import { Colors, Services } from '@sigma-frontend-libs/commons'
import { DICTIONARIES, DICTIONARIES_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { icons } from '@/utils'

export const dictionariesStatuses = {
  [DICTIONARIES_STATUSES.created]: {
    icon: icons.bookmark_border,
    color: Colors.grey
  },
  [DICTIONARIES_STATUSES.ready]: {
    icon: icons.bookmark,
    color: Colors.primary
  },
  [DICTIONARIES_STATUSES.importing]: {
    icon: icons.history,
    color: Colors.grey
  },
  [DICTIONARIES_STATUSES.compiling]: {
    icon: icons.autorenew,
    color: Colors.grey
  },
  [DICTIONARIES_STATUSES.compiled]: {
    icon: icons.check_circle_outline,
    color: Colors.primary
  },
  [DICTIONARIES_STATUSES.importError]: {
    icon: icons.highlight_off,
    color: Colors.error
  },
  [DICTIONARIES_STATUSES.compileError]: {
    icon: icons.highlight_off,
    color: Colors.error
  },
  [DICTIONARIES_STATUSES.activated]: {
    icon: icons.check_circle,
    color: Colors.success
  },
  [DICTIONARIES_STATUSES.downloading]: {
    icon: icons.download,
    color: Colors.primary
  }
}

export const dictionaryActions = {
  set: 'set',
  unset: 'unset',
  import: 'import',
  compile: 'compile',
  remove: 'remove'
}

export const dictionaryToService = type => {
  switch (type) {
    case DICTIONARIES['phone:mnp']: return Services.mnp
    case DICTIONARIES['phone:ranges']: return Services.prefixes
    case DICTIONARIES['phone:opgroups']: return Services.operatorGroups
    default: return undefined
  }
}
